import {
    getFuelLoading,
    getFuelReject,
    getFuelRequest,
    getFuelSuccess
} from "../../actions/fuel/getAll";

export const getFuel = (formData) => async (dispatch, getState) => {
    dispatch(getFuelLoading());
    try {
        const { data } = await getFuelRequest(formData, getState);
        dispatch(getFuelSuccess(data))
    } catch (error) {
        dispatch(getFuelReject(error))
    }
    return Promise.resolve();
};